import { StrictRouteConfig } from "@/router/router";

export const zoneRoutes: StrictRouteConfig[] = [
    {
        path: "/customers/:customerId/offices/:officeId/zones",
        name: "zones",
        component: () => import(/* webpackChunkName: "floor" */ "@/views/office/zones.vue"),
        meta: {
            requiresAuth: true,
            label: "Zones",
            title: "Manage zones",
            includeInSubNavigation: true,
            icon: "selection",
            matchExact: false,
            path: ["dashboard", "offices", "office", "zones"],
            order: 30,
        },
    },
    {
        path: "/customers/:customerId/offices/:officeId/floors/:floorId/zone/:zoneId",
        name: "zone",
        component: () => import(/* webpackChunkName: "zone" */ "@/views/office/zone.vue"),
        meta: {
            requiresAuth: true,
            label: "Zone",
            title: "Manage zone",
            icon: "select",
            matchExact: false,
            path: ["dashboard", "offices", "office", "floors", "floor", "zone"],
        },
    },
    {
        path: "/customers/:customerId/offices/:officeId/floors/:floorId/zone/:zoneId/restrictions",
        name: "restrictions",
        component: () => import(/* webpackChunkName: "zone" */ "@/views/office/restrictions.vue"),
        meta: {
            requiresAuth: true,
            label: "Zone",
            title: "Manage zone",
            icon: "select",
            matchExact: false,
            path: ["dashboard", "offices", "office", "floors", "floor", "zone"],
        },
    },
    {
        path: "/customers/:customerId/offices/:officeId/floors/:floorId/zone/:zoneId/desks",
        name: "desks",
        component: () => import(/* webpackChunkName: "zone" */ "@/views/office/desks.vue"),
        meta: {
            requiresAuth: true,
            label: "Zone",
            title: "Manage zone",
            icon: "select",
            matchExact: false,
            path: ["dashboard", "offices", "office", "floors", "floor", "zone"],
        },
    },
];
